import request from '../../utils/request';

// OVO-113 — partner-scoped recurring orders API.

export function listSchedulesForPartner(partnerId) {
  return request(`/partners/${partnerId}/schedules`, { method: 'GET' });
}

// Partner-viewer read-only listing — scoped to the caller's own partner
// via the JWT (no partnerId in the URL; the backend derives it).
export function getMySchedules() {
  return request(`/partners/me/schedules`, { method: 'GET' });
}

export function getSchedule(id) {
  return request(`/schedules/${id}`, { method: 'GET' });
}

export function createSchedule(partnerId, data) {
  return request(`/partners/${partnerId}/schedules`, { method: 'POST', data });
}

export function updateSchedule(id, data) {
  return request(`/schedules/${id}`, { method: 'PATCH', data });
}

export function deleteSchedule(id) {
  return request(`/schedules/${id}`, { method: 'DELETE' });
}

// Manual-trigger materialization — used by the operator-side "run for
// X date" button (backfill) and exposed for ad-hoc testing.
export function materializeSchedules(partnerId, payload) {
  return request(`/partners/${partnerId}/schedules/materialize`, {
    method: 'POST',
    data: payload || {},
  });
}

// OVO-113 — Discover recurring schedules from historical orders.
// Scans the last N days (default 90) and proposes (pickupSite,
// deliverySite, weekday-mask) candidates with their confidence stats.
export function discoverSchedules(partnerId, windowDays) {
  const qs = windowDays ? `?windowDays=${windowDays}` : '';
  return request(`/partners/${partnerId}/schedules/discover${qs}`, { method: 'GET' });
}

export function listMaterializationLogs(partnerId, params) {
  let qs = '';
  if (params) {
    qs = '?' + new URLSearchParams(params).toString();
  }
  return request(`/partners/${partnerId}/schedules/logs${qs}`, { method: 'GET' });
}

// #83 — "Regenerate now": re-materialise + rebuild the partner's rolling window
// (J+1 … J+horizon) after a recurring schedule changed. FIXED_TOURS partners only
// rebuild routes; the materialization half runs for every partner.
export function regenerateRoutesWindow(partnerId, { dryRun = false } = {}) {
  return request('/route-generation/regenerate-window', { method: 'POST', data: { partnerId, dryRun } });
}
